module.exports = __webpack_public_path__ + "img/Left.a76255b2.svg";